var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { spacing } from 'syf-component-library/defaultTheme';
import TextArea from 'syf-component-library/ui/atoms/Textarea';
import { t } from '../../../strings/i18n/i18n';
import Icon from '../../../ui/atoms/Icon';
import { ADDITIONAL_INFO_COMMENT_CHARACTER_LIMIT, ALLOWED_SPECIAL_CHARS } from '../../../const/characterValidation';
import formatNumberWithComma from '../../../helpers/formatNumber';
import SpecialCharacterReminder from '../../../ui/atoms/SpecialCharacterReminder';
import SectionDescription from '../SectionDescription';
var AdditionalInfoContainer = styled.section(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"])), spacing.base);
var TextAreaWrapper = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: inline-block;\n  width: 100%;\n"], ["\n  display: inline-block;\n  width: 100%;\n"])));
var AdditionalInfoComment = function (_a) {
    var userComment = _a.userComment, userCommentError = _a.userCommentError, handleChange = _a.handleChange;
    var charactersRemaining = ADDITIONAL_INFO_COMMENT_CHARACTER_LIMIT - userComment.length;
    var numberWithComma = formatNumberWithComma(charactersRemaining);
    var reminderText = t('additionalInfo.reminder', {
        specialCharacters: ALLOWED_SPECIAL_CHARS
    });
    var helpText = charactersRemaining === 1
        ? t('questionnaire.oneCharacterCountHelpText')
        : t('questionnaire.characterCountHelpText', {
            charactersRemaining: numberWithComma
        });
    return (_jsxs(AdditionalInfoContainer, __assign({ "data-cy": "additional-information-section" }, { children: [_jsx(SectionDescription, { sectionHeading: t('additionalInfo.commentSectionTitle'), sectionDescription: t('additionalInfo.commentSectionDescription'), size: "medium" }), _jsx(TextAreaWrapper, { children: _jsx(TextArea, { id: "syf-text-area", placeholder: t('additionalInfo.commentSectionTitle'), value: userComment, onChange: handleChange, error: userCommentError, errorIcon: _jsx(Icon, { name: "falExclamationCircle", size: "sm" }), helpText: helpText, dynamicHeight: true, dynamicHeightMax: 148 }) }), userCommentError !== reminderText && (_jsx(SpecialCharacterReminder, __assign({ "data-cy": "special-character-reminder" }, { children: reminderText })))] })));
};
export default AdditionalInfoComment;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map